import { useLayoutEffect } from "react"
import { useUnit } from "effector-react"
import reservationSidebars from "stores/reservationSidebars"
import pendingReservationSidebarStore from "stores/pendingReservationSidebar"

/**
 * Global component that automatically handles pending reservation sidebar requests
 * across all pages without requiring individual hook implementations.
 * 
 * This should be included once at the app level to provide automatic
 * sidebar opening behavior throughout the application.
 */
const GlobalReservationSidebarHandler = () => {
    const pendingReservationSidebar = useUnit(pendingReservationSidebarStore.$pendingReservationSidebar)

    useLayoutEffect(() => {
        if (pendingReservationSidebar.reservationId) {
            // Small delay to ensure page has fully loaded and rendered
            const timeoutId = setTimeout(() => {
                reservationSidebars.show({
                    reservationId: pendingReservationSidebar.reservationId!,
                    initTabIndex: pendingReservationSidebar.initTabIndex,
                    onDelete: pendingReservationSidebar.onDelete || (() => {})
                })
                pendingReservationSidebarStore.clearPendingReservationSidebar()
            }, 100)

            return () => clearTimeout(timeoutId)
        }
    }, [pendingReservationSidebar])

    return null
}

export default GlobalReservationSidebarHandler
